"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var React = require("react");
var solid_ui_1 = require("solid-ui");
var dom_1 = require("./dom");
var Pane_1 = require("./Pane");
var thisPane = {
    global: false,
    icon: solid_ui_1.icons.iconBase + "noun_15695.svg",
    name: "activitystreams",
    label: function (subject, context) {
        var t = context.session.store.findTypeURIs(subject);
        if (t[solid_ui_1.ns.as("Note").uri]) {
            return "Note";
        }
        return null;
    },
    render: function (subject, context) {
        return (0, dom_1.createElement)(React.createElement(Pane_1.Pane, { subject: subject, context: context }));
    },
};
exports.default = thisPane;
//# sourceMappingURL=index.js.map